import { csrfTokenService } from '../csrf/CsrfTokenService'

interface ValidateTokenResponse {
  email?: string
}

export class ValidateResetPasswordTokenRepositoryFetch {
  async validate(token: string, uid: string): Promise<ValidateTokenResponse> {
    return await this.getResponse(token, uid)
  }

  private async getResponse(
    token: string,
    uid: string,
  ): Promise<ValidateTokenResponse> {
    const { csrfToken } = await csrfTokenService()
    return await $fetch<ValidateTokenResponse>(
      '/_/fallback/_/users/validate-token/',
      {
        method: 'POST',
        body: this.getFormData(token, uid),
        headers: {
          'X-CSRFToken': csrfToken,
        },
        credentials: 'include',
      },
    )
  }

  private getFormData(token: string, uid: string) {
    const formData = new FormData()
    formData.append('token', token)
    formData.append('uid', uid)
    return formData
  }
}
